import { compose } from 'recompose'
import { connect } from 'react-redux'

import { selectors as NotesSelectors } from 'data/notes'

import fetchAllTemplateNotes from 'components/Templates/dataSync/fetchesAllTemplateNotes'
import providesApplyTemplateOnNote from 'components/Templates/dataSync/providesApplyTemplateOnNote'

export default compose(
  fetchAllTemplateNotes(),
  providesApplyTemplateOnNote,
  connect(state => {
    const listState = NotesSelectors.getAllTemplateNotesListState(state)
    return {
      emptyList: !listState.loading && !listState.totalCount,
      templateNotes: NotesSelectors.getAllTemplateNotes(state),
      activeNoteId: NotesSelectors.getActiveNote(state).id,
    }
  })
)
